import React, {ReactNode} from 'react';
import './DataSourcePage.css';
import {Link, Outlet} from 'react-router-dom';
import usePermissions from "./hooks/usePermissions";

interface DataSourcePageProps {
    rightContent?: ReactNode;
}

const AdministrationPage: React.FC<DataSourcePageProps> = () => {
    const {permissions} = usePermissions();

    const hasPermission = (requiredPermissions: string[]): boolean => {
        return requiredPermissions.some(permission => permissions.includes(permission));
    };

    return (
        <div className="data-source-page">
            <div className="data-source-container">
                <div className="data-source-sidebar">
                    <h2>Administration</h2>
                    <ul>
                        {hasPermission(['view_users']) && (
                            <li>
                                <Link to="/administration/users" className="link">
                                    Users
                                </Link>
                            </li>
                        )}
                        {hasPermission(['ip_whitelist']) && (
                            <li>
                                <Link to="/administration/ip-whitelist" className="link">
                                    IP White List
                                </Link>
                            </li>
                        )}
                        {/*<li>*/}
                        {/*    <Link to="/administration/permissions" className="link">*/}
                        {/*        Permissions*/}
                        {/*    </Link>*/}
                        {/*</li>*/}
                        {hasPermission(['list_tenants']) && (
                            <li>
                                <Link to="/administration/tenant" className="link">
                                    Tenant Form
                                </Link>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="data-source-main-content">
                    <Outlet/>
                </div>
            </div>
        </div>
    );
};

export default AdministrationPage;
